export default __webpack_public_path__ + "static/media/help.431833ab.svg";